import { UUID } from 'symbols';

export interface StorageLocationModel {
  id: UUID;
  parentId: UUID;
  parent?: StorageLocationModel;
  name: string;
  isEmpty?: boolean;
}

export interface StorageLocationTreeModel {
  currentFolder?: StorageLocationModel;
  childrenFolders: StorageLocationModel[];
  parentFolders: StorageLocationModel[];
}


export interface NomenclatureModel {
  id: UUID;
  locationId: UUID;
  location: StorageLocationModel;
  name: string;
  price: number;
  wholesale: number;
  payment: number;
  article?: string;
  stockView?: StorageStockViewModel;
}

export interface StorageStockViewModel {
  nomenclatureId: UUID,
  stock: number
}

export interface MoveStorageModel {
  items: UUID[],
  folders: UUID[],
  locationId: UUID
}

export interface CreateStorageLocationModel {
  name: string;
  parentId?: UUID;
}

export const markFolders = (
  currentLocationId: UUID,
  allLocations: StorageLocationModel[],
  goods: NomenclatureModel[],
  currentFolders: StorageLocationModel[]
): StorageLocationModel[] => {
  const folderMap = new Map<UUID, StorageLocationModel>();

  const buildFolderMap = (folders: StorageLocationModel[]) => {
    for (const folder of folders) {
      if (!folderMap.has(folder.id)) {
        folder.isEmpty = true;
        folderMap.set(folder.id, folder);

        const children = allLocations.filter(f => f.parentId === folder.id);
        buildFolderMap(children);
      }
    }
  };

  const rootFolders = allLocations.filter(folder => folder.parentId === null);
  buildFolderMap(rootFolders);
  for (const equipment of goods) {
    let currentFolder = folderMap.get(equipment.locationId);
    while (currentFolder) {

      if (currentFolder.isEmpty === false) {
        break;
      }

      currentFolder.isEmpty = currentFolder.parentId !== (currentLocationId || null);

      if (currentFolder.parentId) {
        currentFolder = folderMap.get(currentFolder.parentId);
      } else {
        break;
      }
    }
  }

  const markedFolders = Array.from(folderMap.values());

  return currentFolders.map(f => {
    const folder = markedFolders.find(mf => mf.id === f.id);
    if (folder) {
      return {
        ...folder,
        isEmpty: folder.isEmpty
      };
    }
    return f;
  });
};


export interface ImportStorageResponse {
  newArticles: {
    name: string;
    art: string;
    price: number;
  }[];
  existingArticles: {
    preview: { name: string; art: string; price: number };
    next: { name: string; art: string; price: number };
  }[];
}
